ko.bindingHandlers.templateSwitcher = {
  update: function(element, valueAccessor, allBindings, viewModel, bindingContext) {
    var binding, displayTemplate, errorTemplate, hasErrored, isLoading, loadingTemplate, newValueAccessor, noContentTemplate, templateInfo, templateToRender, value;
    binding = ko.unwrap(valueAccessor());
    isLoading = ko.unwrap(binding.loading);
    hasErrored = ko.unwrap(binding.error) || false;
    value = ko.unwrap(binding.value);
    templateInfo = binding.templates || {};
    loadingTemplate = templateInfo.loading || 'cyclops.templateSwitcherLoadingTemplate';
    noContentTemplate = templateInfo.empty || 'cyclops.templateSwitcherEmptyTemplate';
    errorTemplate = templateInfo.error || 'cyclops.templateSwitcherErrorTemplate';
    displayTemplate = templateInfo.display;
    if (displayTemplate === void 0 || displayTemplate === null) {
      throw 'You Must define a display template. e.g. templates: { display: \'myTemplate\' }';
    }
    templateToRender = void 0;
    if (isLoading) {
      templateToRender = loadingTemplate;
    } else if (hasErrored) {
      templateToRender = errorTemplate;
    } else {
      if ($.isArray(value) && value.length < 1) {
        templateToRender = noContentTemplate;
      } else if (!value) {
        templateToRender = noContentTemplate;
      } else {
        templateToRender = displayTemplate;
      }
    }
    newValueAccessor = function() {
      return templateToRender;
    };
    ko.bindingHandlers['template']['update'](element, newValueAccessor, allBindings, viewModel, bindingContext);
  }
};

ko.virtualElements.allowedBindings.templateSwitcher = true;
